import { render, staticRenderFns } from "./ComparatorHeader.vue?vue&type=template&id=ff40edd4&scoped=true"
import script from "./ComparatorHeader.vue?vue&type=script&lang=ts"
export * from "./ComparatorHeader.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff40edd4",
  null
  
)

export default component.exports